<template>
  <div
    v-if="customer"
    class="flex size-12 min-w-12 cursor-auto items-center justify-center rounded-full bg-gray-lightest font-bold text-black"
  >
    <template v-if="customer.avatar_url">
      <img
        :src="customer.avatar_url + '?w=' + size + '&auto=compress'"
        :alt="customerName"
        class="size-full rounded-full"
      />
    </template>
    <template v-else>
      {{ initials }}
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { CommunityAuthor } from '@/__generated__/gateway/graphql';
import { getPublicAuthorName } from '@/components/community/utils/helpers';

const props = withDefaults(
  defineProps<{
    customer: Pick<CommunityAuthor, 'username' | 'avatar_url'>;
    size?: string;
  }>(),
  { size: '100' }
);

const customerName = computed(() => getPublicAuthorName(props.customer));
const initials = computed(() => customerName.value.charAt(0).toUpperCase());
</script>
